import React, { useContext } from 'react';
import * as sc from '|/app/header/header.styles';
import { Summary } from '|/app/services';
import SummaryContext from '|/app/summary-context';
import currency from '|/helpers/currency';
import PurchaseHeaderCart from '|/icons/purchase-header-cart.svg';

const defaultProps = {
  orderSummary: null as null | Summary
};

const Cart = ({ orderSummary } = defaultProps) => {
  const {
    vehicle = null,
    totals: { totalPrice: vehicleTotalPrice = null } = {},
    orderPlacedDateTime = null
  } = orderSummary || {};
  const { showSummary, setShowSummary } = useContext(SummaryContext);

  const style = vehicle === null ? {} : { cursor: 'pointer' };

  if (
    vehicle === null ||
    vehicleTotalPrice === null ||
    orderPlacedDateTime !== null
  )
    return null;

  return (
    <sc.CartWrapper
      onClick={() => {
        if (vehicle) setShowSummary(!showSummary);
      }}
      style={style}
      data-analytics-id="pp_header_cart"
    >
      <PurchaseHeaderCart />
      {currency(vehicleTotalPrice)}
    </sc.CartWrapper>
  );
};

export default Cart;
